import React from 'react'
import PinchZoomPan from "react-responsive-pinch-zoom-pan";
import Modal from '@material-ui/core/Modal';
import style from 'style/ModalImageViewer.css';

class ModalImageViewer extends React.Component{
  constructor(props) {
    super(props)
    this.state = {
      open: false,
      imageSrc:''
    }
  }
  handleClose = () => {
    this.setState({open:false})
  }

  openModal = (src)=>{
    this.setState({imageSrc:src, open:true})
  }

  render() {
    return (
      <Modal

        open={this.state.open}
        onClose={this.handleClose}
      >
        <div class="modal-image-viewer">
          <div class="modal-image-viewer-header" onClick={this.handleClose}> بستن</div>
          <PinchZoomPan zoomButtons={false} position='center'>
            <img src={this.state.imageSrc} />
          </PinchZoomPan>
        </div>
      </Modal>
    )
  }
}
export default ModalImageViewer